import request from '@/utils/request'

// 查询种子仓库分页
export function pageSeedWarehouse(data) {
  return request({
    url: '/cloudplant/seedwarehouse/page',
    method: 'post',
    data: data,
    headers: { repeatSubmit: false }
  })
}

// 查询种子仓库详情
export function getSeedWarehouse(data) {
  return request({
    url: '/cloudplant/seedwarehouse/detail',
    method: 'get',
    params: data
  })
}

// 平台确认种子
export function confirmSeedWarehouse(data) {
  return request({
    url: '/cloudplant/seedwarehouse/confirm',
    method: 'post',
    data: data
  })
}
